export const API_URL: string = process.env.REACT_APP_API_URL!;
export const WS_URL: string = process.env.REACT_APP_WS_URL!;
export const PERSIST_KEY = process.env.REACT_APP_PERSIST_KEY!;
export const ONE_SIGNAL_APP_ID = process.env.REACT_APP_ONE_SIGNAL_APP_ID!;
export const WHATSAPP_GROUP_LINK = process.env.REACT_APP_WHATSAPP_GROUP_LINK!;
